import type { RoundShareIconButtonChannel } from '#src/app/shared/components/share';

// `share_placement` distinguishes WHERE in the slide-up a share was fired: a prominent action button (the
// channel-aware CTA / Copy-link primary) vs. a socials-grid icon. It's orthogonal to the event's own
// `location` (the channel/network), so analysis can tell e.g. "Facebook share from the CTA" apart from
// "Facebook share from the grid". Passed as a tracking-data override to the share button.
export const ACTION_BUTTON_TRACKING_DATA = { share_placement: 'action_button' } as const;
export const CHANNEL_GRID_TRACKING_DATA = { share_placement: 'channel_grid' } as const;

// CHANGE-94078: experiment-winning 60×60 share icons, applied as a one-off custom size (no DS token;
// same call-site pattern as InlineShareChannelsCarousel). Sizes the circle to 60px and the glyph to 38px.
// see https://change.slack.com/archives/C080XM670A2/p1780509061236909
export const SHARE_ICON_SIZE_CLASSNAME =
	'[&>*:first-child]:size-[60px] [&>*:first-child>*:first-child]:size-[60px] [&>*:first-child>*:first-child]:!transform-none [&>*:first-child>*:first-child>*:first-child]:size-[38px] [&_svg]:size-[38px]';

// These channels open an educational modal — the slide-up must close first to avoid stacked modals
const CHANNELS_WITH_EDUCATION_MODAL: readonly RoundShareIconButtonChannel[] = [
	'instagram',
	'instagramStories',
	'tiktok',
];

export function getShareIconOnBeforeShare({
	channel,
	close,
	closeOnSocialShare,
}: {
	channel: RoundShareIconButtonChannel;
	close: () => void;
	closeOnSocialShare: boolean;
}): (() => void) | undefined {
	// Copy link shows an inline "Copied!" confirmation on the button itself (variant_2 renders it in the
	// grid); closing the sheet would unmount it before the user sees it, so keep the sheet open — matching
	// how the standalone Copy link button behaves.
	if (channel === 'copy') return undefined;
	return !closeOnSocialShare && !CHANNELS_WITH_EDUCATION_MODAL.includes(channel) ? undefined : close;
}
